import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import io from 'socket.io-client';
import ticketSorteo from './images/ticketSorteo.png';
import biruxComodin112 from './images/biruxComodin112.png';
import gragea from './images/gragea.png';
import biruxPlata from './images/biruxPlata112.png';
import biruxOro from './images/biruxOro112.png';
import twitchLogo from './images/twitchLogoSquare.png';
import youtubeLogo from './images/youtubeLogoSquare.png';
import heroe from './images/heroe256.png';
import villano from './images/villano256.png';
import over from './images/over256.png';
import ataque from './images/ataque50.png';
import agilidad from './images/agilidad50.png';
import velocidad from './images/velocidad50.png';
import corazon from './images/corazon64.png';
import LoginOnProgress from './loginOnProgress';
import TwitchLink from './components/twitchLink';
import YoutubeLink from './components/youtubeLink';
import { faccionKey } from '../utils/faccion';
import { ArenaPopUp, ArenaHistorial, ArenaNivel, ArenaEquipo, AVISO_DIRECTO } from './arena';
import { useTutorial } from './components/Tutorial';
import top112 from './images/top112.png';
const User = ({ userPlayer, authPlatform }) => {

    const [user, setUser] = React.useState([]);
    const [twitchActivity, setTwitchActivity] = React.useState('0 Segundos.');
    const [youtubeActivity, setYoutubeActivity] = React.useState('0 Segundos.');
    const [loading, setLoading] = React.useState(true);
    const [menuTab, setMenuTab] = React.useState(0);
    // Arena Forallia: Luchar e Historial solo en tu propia cuenta.
    const arena = !!userPlayer;
    const [luchando, setLuchando] = React.useState(false);
    const tutorial = useTutorial();
    // Sube al cerrar el popup de Luchar: vuelven a pedirse el perfil (nivel, vida, stats), la XP y el historial.
    const [historialVer, setHistorialVer] = React.useState(0);
    // El estado de la arena que pide ArenaNivel: la pestaña Equipo sale si tienes alguna arma o mascota.
    const [arenaEstado, setArenaEstado] = React.useState(null);
    const equipable = !!arenaEstado && arenaEstado.objetos.some(o => o.tipo !== 'habilidad');
    // Narux en directo: el personaje se ha ido a verle y no se puede luchar. Llega con el perfil y se
    // actualiza al empezar o acabar el directo.
    const [enDirecto, setEnDirecto] = React.useState(false);
    useEffect(() => {
        if (!arena) return;
        const socket = io('https://forallia.com');
        socket.on('status', (s) => setEnDirecto(s === 'ON'));
        return () => socket.disconnect();
    }, [arena]);
    // Con sesion de admin el directo no cierra la arena.
    const cerrada = arena && enDirecto && !(user.arena && user.arena.libre);
    function isSub(subStatus) {
        if (!subStatus) {
            return "No se ha subscrito nunca.";
        } else {
            return "Activo";
        }
    }

    let { username } = useParams();
    useEffect(() => {
        if (userPlayer) {
            username = userPlayer.displayname;
        }
        if (username) {
            fetch('/api/user/' + username, { method: 'POST' })
                .then(response => response.json())
                .then(data => {
                    setUser(data);
                    setEnDirecto(!!(data && data.arena && data.arena.enDirecto));
                    setTwitchActivity(setTime(data.activityTwitchTime));
                    setYoutubeActivity(setTime(data.activityYoutubeTime));
                    setLoading(false);
                })
        }
    }, [userPlayer, historialVer]);

    function setTime(seconds) {
        let string = 'Tiempo de actividad: ';
        if (seconds) {
            if (seconds <= 60) {
                string += seconds + ' Seg';
            } else
                if (seconds > 60 && seconds <= 3600) {
                    string += (seconds / 60).toFixed(2) + ' Min';
                } else
                    if (seconds > 3600 && seconds <= 86400) {
                        string += (seconds / 60 / 60).toFixed(2) + ' H';
                    } else
                        if (seconds > 86400 && seconds <= 2419200) {
                            string += (seconds / 60 / 60 / 24).toFixed(2) + ' D';
                        } else
                            if (seconds > 2419200 && seconds <= 29030400) {
                                string += (seconds / 60 / 60 / 24 / 28).toFixed(2) + ' M';
                            }
        } else {
            string = 'No hay tiempo de actividad registrado.'
        }
        return string;
    }

    if (loading) {
        return (<LoginOnProgress />)
    } else if (user.displayname == undefined ||
        user.hp == undefined ||
        user.hp_max == undefined ||
        user.ptsorteo == undefined ||
        user.sub == undefined) {
        return (
            <div className="core">
                <div className="playerName">El personaje no existe o está desactualizado.</div>
                <div className="playerName">(Escribe en el chat o conectate durante el stream para crear o actualizar tu personaje).</div>
            </div>
        )
    } else if (user.faccion == undefined) {
        return (
            <div className="core">
                <div className="playerName">El personaje no está en ninguna facción.</div>
                <div className="playerName">(Canjea la facción en Twitch).</div>
            </div>
        )
    } else {
        const avatar = user.twitchImage || user.youtubeImage;
        const faccion = faccionKey(user.faccion);
        return (
            <div className="core">
                <div className="playerName"><span className={user.faccion + "String"}>{user.faccion}</span> {user.displayname}</div>
                <div className='social-links'>
                    {user.usert ? <TwitchLink displayname={user.displayname} /> : null}
                    {user.useryt ? <YoutubeLink channelId={user.useryt} /> : null}
                </div>
                <div className='playerMain'>
                    {/* El avatar de la cuenta flotando, con el marco del color de su faccion.
                        Sin avatar, la imagen de la faccion de siempre. */}
                    <div className='overPlayer avatarPlayer'>
                        {cerrada ? (
                            <div className='avatarFloat arenaDirecto'>
                                <p>Se ha ido a ver a Narux en directo</p>
                                {authPlatform === 'youtube'
                                    ? <a href='https://www.youtube.com/@naruxforall/live' target='_blank' rel='noreferrer' data-red='youtube'>Ver en YouTube</a>
                                    : <a href='https://www.twitch.tv/naruxforall' target='_blank' rel='noreferrer' data-red='twitch'>Ver en Twitch</a>}
                            </div>
                        ) : avatar ? (
                            <div className='avatarFloat accountImageBorder' data-faccion={faccion}>
                                <img src={avatar} alt={user.displayname} width="200" height="200" fetchpriority="high" loading="eager" />
                            </div>
                        ) : (
                            <div className='avatarFloat'>
                                <img src={faccion === 'heroe' ? heroe : faccion === 'villano' ? villano : over} alt={user.faccion} width="256" height="256" fetchpriority="high" loading="eager" />
                            </div>
                        )}
                        {cerrada ? null : <div className='avatarShadow'></div>}
                    </div>
                    <div className='playerMenu unselectable heroes'>
                        <div onClick={() => setMenuTab(0)} className={`btnForallia ${menuTab === 0 ? 'active' : ''}`}>
                            <div className='flex'>
                                <span>Inicio</span>
                            </div>
                        </div>
                        <div onClick={() => setMenuTab(1)} className={`btnForallia ${menuTab === 1 ? 'active' : ''}`}>
                            <div className='flex'>
                                <span>Stats</span>
                            </div>
                        </div>
                        {arena ? <>
                            {cerrada ? (
                                // Sin onClick: en gris y, al pasar por encima (o tocarlo en el movil), el aviso
                                <div className='btnForallia arenaLucharOff' tabIndex={0} aria-disabled='true' aria-describedby='arenaAvisoDirecto'>
                                    <div className='flex'>
                                        <span>Luchar</span>
                                    </div>
                                    <span className='arenaAviso' role='tooltip' id='arenaAvisoDirecto'>{AVISO_DIRECTO}</span>
                                </div>
                            ) : (
                                <div onClick={() => {
                                    setLuchando(true);
                                    // Paso 'luchar' del tutorial (components/Tutorial.jsx)
                                    if (tutorial && tutorial.paso === 'luchar') tutorial.avisar('luchar');
                                }} className='btnForallia arenaLuchar'>
                                    <div className='flex'>
                                        <span>Luchar</span>
                                    </div>
                                </div>
                            )}
                            <div onClick={() => setMenuTab(2)} className={`btnForallia ${menuTab === 2 ? 'active' : ''}`}>
                                <div className='flex'>
                                    <span>Historial</span>
                                </div>
                            </div>
                            {equipable ? (
                                <div onClick={() => setMenuTab(3)} className={`btnForallia ${menuTab === 3 ? 'active' : ''}`}>
                                    <div className='flex'>
                                        <span>Equipo</span>
                                    </div>
                                </div>
                            ) : null}
                        </> : null}
                    </div>
                </div>
                <div className="main">
                    {/* Las dos pestañas se pintan siempre en la misma celda (ver .playerTabs):
                        la caja mide lo que la mas grande, asi que cambiar de pestaña no hace
                        saltar la pagina y las dos empiezan en el mismo borde. */}
                    <div className="playerTabs">
                        <div className={'infoTwitch flexColumn' + (menuTab === 0 ? '' : ' tabHidden')}>
                            <span className='fH'><img src={biruxComodin112}></img> Birux Comodin: {user.biruxComodin || 0}</span>
                            <span className='fH'><img src={ticketSorteo}></img> Tickets Sorteo (histórico): {user.ptsorteo}</span>
                            <span className='fH'><img src={gragea}></img>Plus Ultra: {isSub(user.sub)}</span>
                            <span className='fH'><img src={biruxPlata}></img>Birux Plata: {(user.biruxPlata ? user.biruxPlata : 0)}</span>
                            <span className='fH'><img src={biruxOro}></img>Birux Oro: {(user.biruxOro ? user.biruxOro : 0)}</span>
                            <span className='fH'><img src={twitchLogo}></img>{twitchActivity}</span>
                            <span className='fH'><img src={youtubeLogo}></img>{youtubeActivity}</span>
                        </div>
                        {/* Las de la cuenta, que son las de su luchador de la arena (las manda /api/user). */}
                        {user.arena ?
                            <div className={'infoTwitch flexColumn' + (menuTab === 1 ? '' : ' tabHidden')}>
                                <span className='fH'><img src={corazon}></img>Vida: {user.arena.vida}</span>
                                <span className='fH'><img src={ataque}></img>Ataque: {user.arena.fuerza}</span>
                                <span className='fH'><img src={agilidad}></img>Agilidad: {user.arena.agilidad}</span>
                                <span className='fH'><img src={velocidad}></img>Velocidad: {user.arena.velocidad}</span>
                                {/* En tu cuenta, la XP y la mejora por elegir; al elegirla se ven ya las stats nuevas. */}
                                {arena
                                    ? <ArenaNivel key={historialVer} onEstado={setArenaEstado} onStats={(s) => setUser(u => ({ ...u, arena: { ...u.arena, ...s } }))} />
                                    : <span className='fH'><img src={top112}></img>Nivel: {user.arena.nivel}</span>}
                            </div> : null}
                        {menuTab === 2 ? <ArenaHistorial key={historialVer} /> : null}
                        {menuTab === 3 && equipable ? <ArenaEquipo key={arenaEstado.objetos.length} objetos={arenaEstado.objetos} equipo={arenaEstado.equipo} /> : null}
                    </div>
                </div>
                {luchando ? <ArenaPopUp onClose={() => { setLuchando(false); setHistorialVer(v => v + 1); }} /> : null}
            </div>


        )
    }
}
export default User;

